// extracted by mini-css-extract-plugin
module.exports = {"base":"BadgeTag_base__1ZvqX","label":"BadgeTag_label__2qNDP","preLabel":"BadgeTag_preLabel__2sgDn"};